import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import createPersistedState from "vuex-persistedstate"  //保留vuex数据
import porderDetail from "./modules/porderDetail";
import orderDetail from "./modules/orderDetail";
import transferOrderDetail from "./modules/transferOrderDetail";
export default new Vuex.Store({
  state: {
    rate: 0,//汇率
    menuWidth: '240px',
    menuIconUrl: require('../assets/icon/logo1.svg'),
    isUnfoldMenu: false,
    roleAuth: [],// 角色权限
    leftMenu: [], //左侧菜单
    userMenu: [],//客户授权菜单
    userID: '',//客户授权客户ID
    menu: JSON.parse(localStorage.getItem("menu")),
    selectMenuIndex: 0,//当前头部菜单选中的菜单项索引
    orderStatusList: [],//整个订单所有状态
    typeList: [], //所有订单类型
    orderDetailStatus: [],//单番商品所有状态MAP
    authWorkGroupAdmin: {
      y: [],
      g: [],
      p: [],
      f: [],
      s: [],
      j: [],
      z: [],
    },//各工种账号列表
    organizationList: [],//组织列表
    problemTypes: [],//问题产品-所有可选类型
    problemDialogVisible: false,//是否显示问题产品弹窗
    problemList: [],//问题产品列表
    schedule: 100,//进图条
  },
  mutations: {
    // 获取左侧路由
    setLeftMenu(state, data) {
      state.leftMenu = data
    },

    // 用户授权用户ID
    setUserID(state, data) {
      state.userID = data
    },
    // 获取头部路由
    setmenu(state, data) {
      state.menu = data
    },
    // 获取角色权限
    setRoleAuth(state, data) {
      state.roleAuth = data
    },
    //更新头部选中的菜单索引
    updateSelectMenuIndex(state, data) {
      state.selectMenuIndex = data;
      if (state.menu[data].child_menus.length === 0) {
        state.leftMenu = [];
      } else {
        state.leftMenu = state.menu[data].child_menus;
      }
    },
    //更新菜单折叠状态
    updateIsUnfoldMenu(state, data) {
      state.isUnfoldMenu = data
      data === false ? state.menuIconUrl = require('../assets/icon/logo1.svg') : state.menuIconUrl = require('../assets/icon/logo2.svg')
    },
    // 获取整个订单所有状态
    setOrderStatusList(state, data) {
      state.orderStatusList = data
    },
    // 所有订单类型
    setTypeList(state, data) {
      state.typeList = data
    },
    // 单番商品所有状态MAP
    setOrderDetailStatusMap(state, data) {
      state.orderDetailStatus = data
    },
    //各工种账号列表
    setAuthWorkGroupAdmin(state, data) {
      data.z = [...data.p, ...data.j]
      state.authWorkGroupAdmin = data
    },
    //组织列表
    setOrganizationList(state, data) {
      state.organizationList = data
    },
    //问题产品-所有可选类型
    setProblemTypes(state, data) {
      state.problemTypes = data
    },
    // 是否显示问题产品
    setProblemDialogVisible(state, data) {
      state.problemDialogVisible = data
    },
    // 问题产品列表
    setProblemList(state, data) {
      state.problemList = data
    },
    // 获取汇率
    setExchangeRat(state, data) {
      state.rate = data
    },
    // 设置进度条
    setSchedule(state, data) {
      state.schedule = data
    }

  },
  actions: {
    //更新左侧菜单的width
    updateMenuWidth(state, params) {
      const { id } = params;
      state.menuWidth = id + 'px';
    },
    // 拥有的权限
    userAuth({ commit }) {
      Vue.prototype.$api.userAuth().then(res => {
        localStorage.setItem('japanUserAuth', JSON.stringify(res.data))
      })
    },
    // 菜单
    getMenu({ commit }) {
      Vue.prototype.$api.menu().then(res => {

        // 用户授权管理
        let userMenu = res.data.find(item => item.name == '客户授权管理')
        let menu = res.data.filter(item => item.show)

        commit('setmenu', menu);
        commit('setLeftMenu', menu[0].child_menus)
        localStorage.setItem('userMenu', JSON.stringify(userMenu.child_menus))
        localStorage.setItem('menu', JSON.stringify(menu))
      })
    },
    // 整个订单所有状态
    orderStatusMap({ commit }) {
      Vue.prototype.$api.orderApi.orderStatusMap().then(res => {
        // res.data.unshift(
        //   { key: '', value: "状态筛选" })
        commit('setOrderStatusList', res.data)

      })
    },
    // 所有订单类型 
    typeList({ commit }) {
      Vue.prototype.$api.orderApi.typeList().then(res => {
        commit('setTypeList', res.data)

      })
    },
    // 单番商品所有状态MAP
    orderDetailStatusMap({ commit }) {
      Vue.prototype.$api.orderApi.orderDetailStatusMap().then(res => {
        commit('setOrderDetailStatusMap', res.data)
      })
    },
    //各工种账号列表
    getAuthWorkGroupAdmin({ commit }) {
      Vue.prototype.$api.getAuthWorkGroupAdminSameLevel().then(res => {
        for (let key in res.data) {
          res.data[key] = res.data[key].filter(item => item.forbid_login == 0)
        }
        commit('setAuthWorkGroupAdmin', res.data)
      })
    },
    // 组织列表
    getOrganizationList({ commit }) {
      Vue.prototype.$api.roleApi.organizationList().then((res) => {
        commit('setOrganizationList', res.data)
      });
    },
    // 问题产品-所有可选类型
    getProblemTypes({ commit }) {
      Vue.prototype.$api.problemApi.types().then((res) => {
        commit('setProblemTypes', res.data)
      });
    },
    // 获取问题产品列表
    getProblemList({ commit }, data) {
      let datas = {
        order_purchase_id: data.order_purchase_id,
      }
      console.log(data);
      Vue.prototype.$api.problemApi.problemStorePreview(datas).then((res) => {
        res.data.forEach(item => {
          item.list.forEach(items => {
            items.image = [{ image: '', client_show: false }, { image: '', client_show: false }, { image: '', client_show: false }, { image: '', client_show: false },]
            items.num = ''
            items.type = data.type
            items.description = ''
            items.inspect_bad_id = ''
            items.pre_num = items.possible_num //- items.inspect_bad_num
            items.pre_price = items.confirm_price
            items.pre_freight = items.confirm_freight

            if (data.inspect_bad_list != false && data.inspect_bad_list != null) {
              data.order_purchase_id.forEach((order_purchase_id, i) => {
                if (order_purchase_id == items.order_purchase_id) {

                  items.inspect_bad_id = data.inspect_bad_list[i].inspect_bad_id
                  items.num = data.inspect_bad_list[i].num //自动把问题产品数预填上
                }
              })
            }

          })
        })

        commit('setProblemList', res.data)
        commit('setProblemDialogVisible', true)
      });
    },
    // 获取汇率
    getExchangeRat({ commit }) {
      Vue.prototype.$api.getExchangeRat().then((res) => {
        commit('setExchangeRat', res.data.rmb_to_jpy)
      });
    },



  },
  modules: {
    porderDetail,
    orderDetail,
    transferOrderDetail,
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})
